import { render, staticRenderFns } from "./RegisterLPStep.vue?vue&type=template&id=8a06e130&scoped=true"
import script from "./RegisterLPStep.vue?vue&type=script&lang=js"
export * from "./RegisterLPStep.vue?vue&type=script&lang=js"
import style0 from "./RegisterLPStep.vue?vue&type=style&index=0&id=8a06e130&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a06e130",
  null
  
)

export default component.exports